const shgcTables = {
  base: {
    N: [
      [1, 0.955, 0.922, 0.897, 0.877, 0.86, 0.846, 0.834, 0.825, 0.817, 0.81], // Lat1
      [1, 0.931, 0.888, 0.86, 0.838, 0.82, 0.806, 0.793, 0.783, 0.775, 0.768], // Lat 2
    ],
    NE: [
      [1, 0.93, 0.876, 0.834, 0.803, 0.779, 0.761, 0.747, 0.737, 0.729, 0.722], // Lat1
      [1, 0.924, 0.864, 0.818, 0.782, 0.755, 0.734, 0.718, 0.706, 0.696, 0.688], // Lat 2
    ],

    E: [
      [1, 0.922, 0.855, 0.796, 0.745, 0.702, 0.666, 0.635, 0.609, 0.587, 0.569], // Lat1
      [1, 0.922, 0.855, 0.797, 0.747, 0.705, 0.67, 0.641, 0.616, 0.596, 0.579], // Lat 2
    ],
    SE: [
      [1, 0.906, 0.824, 0.755, 0.697, 0.652, 0.617, 0.59, 0.569, 0.554, 0.542], // Lat1
      [1, 0.91, 0.834, 0.771, 0.721, 0.682, 0.651, 0.628, 0.61, 0.596, 0.585], // Lat 2
    ],

    S: [
      [1, 0.881, 0.789, 0.719, 0.665, 0.626, 0.598, 0.58, 0.569, 0.563, 0.559], // Lat1
      [1, 0.896, 0.816, 0.754, 0.708, 0.675, 0.653, 0.638, 0.628, 0.621, 0.616], // Lat 2
    ],
    SW: [
      [1, 0.905, 0.823, 0.753, 0.695, 0.65, 0.614, 0.587, 0.566, 0.551, 0.539], // Lat1
      [1, 0.91, 0.834, 0.771, 0.72, 0.681, 0.651, 0.627, 0.609, 0.596, 0.585], // Lat 2
    ],
    W: [
      [1, 0.922, 0.583, 0.794, 0.743, 0.7, 0.663, 0.632, 0.606, 0.585, 0.566], // Lat1
      [1, 0.922, 0.584, 0.796, 0.746, 0.705, 0.67, 0.64, 0.615, 0.535, 0.578], // Lat 2
    ],
    NW: [
      [1, 0.93, 0.875, 0.834, 0.802, 0.778, 0.76, 0.746, 0.736, 0.728, 0.721], // Lat1
      [1, 0.924, 0.864, 0.818, 0.782, 0.755, 0.734, 0.717, 0.705, 0.695, 0.688], // Lat 2
    ],
  },
  right: {
    N: [
      [1, 0.968, 0.943, 0.924, 0.911, 0.899, 0.89, 0.883, 0.877, 0.871, 0.865], //Lat1 >= 23.5N
      [1, 0.962, 0.934, 0.913, 0.9, 0.888, 0.879, 0.872, 0.866, 0.86, 0.855], //Lat2  < 23.5N
    ],

    NE: [
      [1, 0.942, 0.894, 0.855, 0.824, 0.798, 0.777, 0.762, 0.75, 0.739, 0.731],
      [1, 0.948, 0.904, 0.868, 0.84, 0.816, 0.797, 0.782, 0.77, 0.76, 0.752],
    ],

    E: [
      [1, 0.972, 0.949, 0.931, 0.917, 0.905, 0.895, 0.887, 0.881, 0.875, 0.87],
      [1, 0.975, 0.954, 0.937, 0.924, 0.92, 0.903, 0.896, 0.889, 0.884, 0.878],
    ],

    SE: [
      [1, 0.982, 0.968, 0.957, 0.95, 0.944, 0.939, 0.936, 0.933, 0.93, 0.927],
      [1, 0.982, 0.968, 0.957, 0.949, 0.942, 0.936, 0.932, 0.929, 0.925, 0.922],
    ],

    S: [
      [1, 0.961, 0.933, 0.912, 0.898, 0.887, 0.88, 0.875, 0.872, 0.868, 0.865],
      [1, 0.962, 0.932, 0.911, 0.896, 0.885, 0.877, 0.872, 0.867, 0.863, 0.859],
    ],

    SW: [
      [1, 0.965, 0.934, 0.907, 0.884, 0.865, 0.849, 0.837, 0.827, 0.819, 0.812],
      [1, 0.959, 0.924, 0.894, 0.87, 0.849, 0.832, 0.82, 0.81, 0.801, 0.794],
    ],

    W: [
      [1, 0.988, 0.977, 0.968, 0.96, 0.654, 0.648, 0.643, 0.939, 0.935, 0.932],
      [1, 0.984, 0.97, 0.97, 0.958, 0.949, 0.94, 0.933, 0.927, 0.922, 0.913],
    ],

    NW: [
      [1, 0.985, 0.972, 0.961, 0.953, 0.945, 0.939, 0.934, 0.93, 0.926, 0.922],
      [1, 0.984, 0.97, 0.959, 0.95, 0.942, 0.936, 0.931, 0.927, 0.923, 0.919],
    ],
  },
  left: {
    N: [
      [1, 0.968, 0.943, 0.925, 0.912, 0.9, 0.89, 0.884, 0.877, 0.871, 0.866], //Lat1 >=23.5N
      [1, 0.962, 0.933, 0.912, 0.899, 0.887, 0.878, 0.871, 0.865, 0.859, 0.854], //Lat2 < 23.5N
    ],
    NE: [
      [1, 0.985, 0.972, 0.961, 0.953, 0.946, 0.939, 0.935, 0.931, 0.927, 0.923],
      [1, 0.984, 0.97, 0.959, 0.95, 0.942, 0.935, 0.931, 0.926, 0.922, 0.919],
    ],
    E: [
      [1, 0.988, 0.977, 0.968, 0.961, 0.954, 0.948, 0.944, 0.94, 0.936, 0.932],
      [1, 0.984, 0.97, 0.958, 0.949, 0.941, 0.933, 0.928, 0.923, 0.918, 0.913],
    ],
    SE: [
      [1, 0.965, 0.933, 0.906, 0.883, 0.863, 0.846, 0.834, 0.824, 0.815, 0.808],
      [1, 0.959, 0.924, 0.895, 0.87, 0.849, 0.833, 0.82, 0.81, 0.801, 0.794],
    ],
    S: [
      [1, 0.961, 0.932, 0.911, 0.897, 0.886, 0.879, 0.874, 0.871, 0.867, 0.864],
      [1, 0.962, 0.932, 0.911, 0.896, 0.885, 0.877, 0.871, 0.867, 0.869, 0.859],
    ],
    SW: [
      [1, 0.982, 0.967, 0.957, 0.949, 0.943, 0.938, 0.935, 0.932, 0.929, 0.927],
      [1, 0.982, 0.968, 0.956, 0.948, 0.942, 0.936, 0.932, 0.928, 0.925, 0.922],
    ],
    W: [
      [1, 0.972, 0.949, 0.931, 0.916, 0.904, 0.895, 0.887, 0.881, 0.875, 0.87],
      [1, 0.975, 0.954, 0.937, 0.924, 0.913, 0.903, 0.896, 0.89, 0.884, 0.879],
    ],
    NW: [
      [1, 0.942, 0.895, 0.857, 0.826, 0.801, 0.781, 0.766, 0.754, 0.744, 0.736],
      [1, 0.948, 0.904, 0.868, 0.84, 0.816, 0.797, 0.783, 0.771, 0.761, 0.752],
    ],
  },
};

const PFarray = [0.1, 0.19, 0.29, 0.39, 0.49, 0.59, 0.69, 0.79, 0.89, 0.99, 1]; // for comparision
const shadingTypes = ['Horizontal Overhang', 'Vertical fin(R)', 'Vertical fin(L)', 'Combination', 'Balcony-3side-open', 'Balcony-1side-covered', 'Balcony-2side-covered'];
const orientations = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];

export { shgcTables, PFarray, shadingTypes, orientations };
